const SUBJECT_PATHS = {
  booking: 'bookings',
  bookingRequest: 'booking-requests',
};

const getSubjectPath = (subjectType) => {
  const path = SUBJECT_PATHS[subjectType];
  if (!path) throw new Error('Unsupported chat subject type.');
  return path;
};

export class ChatRepository {
  constructor(client) {
    this.client = client;
    this.basePath = '/api/chat';
  }

  async getCustomerConversation(subjectType, referenceCode, chatAccessToken, page = 1, pageSize = 50) {
    const subjectPath = getSubjectPath(subjectType);
    return this.client.request(
      `${this.basePath}/${subjectPath}/${encodeURIComponent(referenceCode)}/messages`,
      {
        params: { page, pageSize },
        headers: { 'X-Chat-Token': chatAccessToken },
        skipAuthRefresh: true,
      }
    );
  }

  async sendCustomerMessage(subjectType, referenceCode, chatAccessToken, payload) {
    const subjectPath = getSubjectPath(subjectType);
    return this.client.request(
      `${this.basePath}/${subjectPath}/${encodeURIComponent(referenceCode)}/messages`,
      {
        method: 'POST',
        body: payload,
        headers: { 'X-Chat-Token': chatAccessToken },
        skipAuthRefresh: true,
      }
    );
  }

  async getCompanyConversation(subjectType, subjectId, page = 1, pageSize = 50) {
    const subjectPath = getSubjectPath(subjectType);
    return this.client.get(
      `${this.basePath}/company/${subjectPath}/${encodeURIComponent(subjectId)}/messages`,
      { page, pageSize }
    );
  }

  async sendCompanyMessage(subjectType, subjectId, payload) {
    const subjectPath = getSubjectPath(subjectType);
    return this.client.post(
      `${this.basePath}/company/${subjectPath}/${encodeURIComponent(subjectId)}/messages`,
      payload
    );
  }
}

